import { render, staticRenderFns } from "./swiper2.vue?vue&type=template&id=a37b9858&scoped=true"
import script from "./swiper2.vue?vue&type=script&lang=js"
export * from "./swiper2.vue?vue&type=script&lang=js"
import style0 from "./swiper2.vue?vue&type=style&index=0&id=a37b9858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37b9858",
  null
  
)

export default component.exports